import { LookupKeyEnum } from '../../defs/api';

export type BillingPeriod = 'monthly' | 'halfyearly' | 'yearly';

export const getBillingPeriodByLookupKey = (lookupKey?: LookupKeyEnum | null): BillingPeriod | null => {
    if (!lookupKey) {
        return null;
    }

    if (
        [
            LookupKeyEnum.Premium,
            LookupKeyEnum.PremiumMonthlyCzk,
            LookupKeyEnum.PremiumMonthlyCzk202411,
            LookupKeyEnum.PremiumMonthlyCzk202605,
        ].includes(lookupKey)
    ) {
        return 'monthly';
    }

    if (lookupKey === LookupKeyEnum.PremiumHalfYearlyCzk202605) {
        return 'halfyearly';
    }

    return 'yearly';
};

export const getPremiumLookupKeyByBillingPeriod = (period: BillingPeriod): LookupKeyEnum => {
    if (period === 'monthly') {
        return LookupKeyEnum.PremiumMonthlyCzk202605;
    }

    if (period === 'halfyearly') {
        return LookupKeyEnum.PremiumHalfYearlyCzk202605;
    }

    return LookupKeyEnum.PremiumYearlyCzk202411;
};

export const getAvailablePremiumLookupKey = (
    lookupKey: LookupKeyEnum | null | undefined,
    availableLookupKeys: readonly string[],
): LookupKeyEnum => {
    if (lookupKey && availableLookupKeys.includes(lookupKey)) return lookupKey;
    const isLegacyMonthly =
        lookupKey &&
        [LookupKeyEnum.Premium, LookupKeyEnum.PremiumMonthlyCzk, LookupKeyEnum.PremiumMonthlyCzk202411].includes(
            lookupKey,
        );
    if (isLegacyMonthly && availableLookupKeys.includes(LookupKeyEnum.PremiumMonthlyCzk202605)) {
        return LookupKeyEnum.PremiumMonthlyCzk202605;
    }
    return (
        availableLookupKeys.includes(LookupKeyEnum.PremiumYearlyCzk202411)
            ? LookupKeyEnum.PremiumYearlyCzk202411
            : availableLookupKeys[0]
    ) as LookupKeyEnum;
};
